export default __webpack_public_path__ + "static/media/chat.0234e733.png";